import { jsx as _jsx } from "react/jsx-runtime";
import { IconChevronDown } from "@tabler/icons-react";
import cx from "clsx";
;
// Other corkscrews open bottles, this one opens collapsable sections. :)
export const Corkscrew = ({ isCollapsed, open }) => (_jsx(IconChevronDown, { onClick: open, className: cx("can-rotate-90-degrees-anticlockwise", { ["can-rotate-90-degrees-anticlockwise.do-rotation"]: isCollapsed }) }));
